import { gql } from "@apollo/client";

import { WISHLIST_UPDATE_FRAGMENT } from "@shared/graphql.fragments";
import { createRequestContext, getClient } from "lib/apolloClient";
import { setUser, userVar } from "lib/user";
import type { WishListUpdateResultType } from "@shared/graphql.types";

import { dispatch } from "@shared/utils.events";
import { withGlobalSpinner } from "./api";

const REMOVE_USER_WISHLIST_ITEM_BY_SKU = gql`
  mutation removeWishlistItemBySKU($sku: String!) {
    removeWishlistItemBySKU(sku: $sku) {
      ...WishListUpdateFragment
    }
  }
  ${WISHLIST_UPDATE_FRAGMENT}
`;

export const removeWishlistItemBySKUInner = async (
  sku: string,
  context: Record<string, unknown>
) => {
  const { wishlist = [] } = userVar() || {};
  const itemInList = wishlist.find((wish) => wish.variant?.sku === sku);

  if (!itemInList) return false;

  const result = await getClient().mutate<{
    removeWishlistItemBySKU: WishListUpdateResultType;
  }>({
    mutation: REMOVE_USER_WISHLIST_ITEM_BY_SKU,
    variables: {
      sku
    },
    context: createRequestContext({ sessionStrategy: "REDIRECT_TO_LOGIN" })
  });
  const removedWish = wishlist.find((item) => item.variant?.sku === sku);

  if (result?.data?.removeWishlistItemBySKU) {
    const { wishes } = result.data.removeWishlistItemBySKU;
    setUser({
      wishlist: wishes
    });
  }
  if (removedWish) {
    dispatch("removeFromWishlist", {
      item: removedWish,
      context
    });
  }
  if (!result.data) throw new Error("No response received");
  return result.data.removeWishlistItemBySKU;
};

export const removeWishlistItemBySKU = (
  sku: string,
  context: Record<string, unknown> = {},
  options?: { runInBackground?: boolean }
) => {
  if (options?.runInBackground) {
    return removeWishlistItemBySKUInner(sku, context);
  }
  return withGlobalSpinner(() => removeWishlistItemBySKUInner(sku, context))();
};
